// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"gZ-z","vrsnlCrossSiteLabel":"hZ-z"};